import { render, staticRenderFns } from "./cart-close.vue?vue&type=template&id=0b16566c&scoped=true&lang=pug&"
import script from "./cart-close.vue?vue&type=script&lang=coffee&"
export * from "./cart-close.vue?vue&type=script&lang=coffee&"
import style0 from "./cart-close.vue?vue&type=style&index=0&id=0b16566c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b16566c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccessibilityBtn: require('/opt/build/repo/library/components/globals/accessibility-btn.vue').default})
